// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const appBuilderThemeOtherPropsSchema = z.strictObject({
	v8ThemeSupport: z.boolean().optional(),
	stateProtection: z.boolean().optional(),
	forceColorScheme: z
		.union([z.literal("light"), z.literal("dark")])
		.optional(),
	iconUrl: z.string().optional(),
	iconDarkUrl: z.string().optional(),
	iconLightUrl: z.string().optional(),
	defaultFontWeightThin: z.string().optional(),
	defaultFontWeightLight: z.string().optional(),
	defaultFontWeight: z.string().optional(),
	defaultFontWeightMedium: z.string().optional(),
	defaultFontWeightBold: z.string().optional(),
});
